/**
 *
 * Section Error
 *
 */
import PropTypes from "prop-types";

function Error(props) {
  return (
    <div class="row">
      <div class="col">
        <div className="step" id="Error">
          <div
            className="buttonClose"
            onClick={(e) => props.emitChangeSection("closeSection", e)}
          >
            &nbsp;
          </div>
           An error has happened
          {props.formData.hasPaid && (
            <div>
              We will contact your soon to the following e-mail address
              {props.formData.senderEmail}
            </div>
          )}
          <div> You can contact us with the e-mail mail@mail.com </div>
        </div>
      </div>
    </div>
  );
}

Error.propTypes = {
  formData: PropTypes.object,
  emitChangeSection: PropTypes.func, // Change step
};
export default Error;
